import { useState, useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'

const useGetCommunity = () => {
  const [communityList, setCommunityList] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const getCommunity = useCallback((page = 1, filters = {}) => {
    setIsLoading(true)
    const useParams = {}

    if (filters.allowIsPro !== undefined) {
      useParams['allowIsPro'] = filters.allowIsPro
    }

    API.request({
      useParams,
      ...API_ROUTER.community.getCommunityList,
      pathKeys: {
        page,
        limit: 10,
      },
    })
      .then(res => {
        setCommunityList(res)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }, [])

  return { communityList, isLoading, getCommunity }
}

export default useGetCommunity
